var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"eqs-search-bar"},[_c('EqsText',_vm._g(_vm._b({attrs:{"clearable":"","hide-details":"","append-icon":"mdi-magnify","el-class":_vm.elClass,"is-required":false},model:{value:(_vm.valueProxy),callback:function ($$v) {_vm.valueProxy=$$v},expression:"valueProxy"}},'EqsText',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }